const EMPTY = 'utils/memoize/noValue';
export const NO_VALUE = Symbol(EMPTY);
const compareArrays = (a, b) => {
    const same = a.length === b.length;
    if (!same) {
        return false;
    }
    for (const [idx, v] of b.entries()) {
        if (!Object.is(v, a[idx])) {
            return false;
        }
    }
    return true;
};
/**
 * Memoizes a function based on its arguments and dependencies, where the
 * comparison algorithm is a shallow equality check based on `Object.is`[^1]
 *
 * [^1]: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
export function memoize(fn, getDeps) {
    let prevDeps = getDeps();
    let prevArgs = [];
    let output = NO_VALUE;
    return (...args) => {
        const deps = getDeps();
        const sameDeps = compareArrays(prevDeps, deps);
        const sameInputs = compareArrays(prevArgs, args);
        if (!sameDeps || !sameInputs || output === NO_VALUE) {
            if (!sameDeps) {
                prevDeps = deps;
            }
            if (!sameInputs) {
                prevArgs = args;
            }
            output = fn(...args);
            if (output === NO_VALUE) {
                throw new Error('Unexpected memoize function return value');
            }
            return output;
        }
        return output;
    };
}
//# sourceMappingURL=memoize.js.map